import type { IBookingResponse } from "../../../../types/callsheet";

export const getCallSheetCompanyDetails = (
  booking?: IBookingResponse | null,
) => {
  const isFuneralHome =
    booking?.booking_type?.toUpperCase() === "FUNERAL_HOME";

  if (isFuneralHome) {
    return {
      name: booking?.funeral_home?.name || "N/A",
      address: booking?.funeral_home?.street_address || "N/A",
    };
  }
  const branch = booking?.contact?.company_branch;

  return {
    name: branch?.company?.name || "N/A",
    address: branch?.company?.street_address || branch?.street_address || "N/A",
  };
};
